// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox-1SHJc","checked":"checked-1aPQv","indeterminate":"indeterminate-jb0cl"};